import React, { Component } from 'react'
import { Modal, ModalBackground, ModalContent, Title, Subtitle, Box, Control, Input, Icon, Button } from 'bloomer'
import { Mutation } from 'react-apollo'
import gql from 'graphql-tag'
import { Link } from 'react-router-dom'

const GET_MODULE_AVAILABLE = gql`
  mutation ($identifier: String!) {
    getModuleAvailable(identifier: $identifier) {
      module { id }
    }
  }
`

export default class ValidadeModule extends Component {
  state = {
    loading: false,
    identifier: ''
  }

  handleChange = async (getModuleAvailable, evt) => {
    const { validateHandler } = this.props
    const identifier = evt.target.value

    this.setState(() => ({identifier}))

    if (!getModuleAvailable) {
      return
    }


    try {
      await getModuleAvailable({
        variables: { identifier }
      })
      this.setState(() => ({loading: true}))
      setTimeout(() => validateHandler(true), 1500)
    } catch (err) {
      this.setState(() => ({loading: false}))
    }
  }

  render() {
    const { loading, identifier } = this.state

    return (
      <Mutation mutation={GET_MODULE_AVAILABLE}>
      {(getModuleAvailable) => {
        return (
          <Modal isActive={true}>
            <ModalBackground />
            <ModalContent>
              <Box>
                <Title isSize={4}>Informe o identificador do módulo adquirido</Title>
                <Subtitle isSize={6}>Veja as instruções no manual</Subtitle>

                <Control hasIcons="right" style={{marginBottom: '1rem'}}>
                  <Input isSize="large" placeholder="Identificador" value={identifier} onChange={this.handleChange.bind(this, getModuleAvailable)} />
                  <Icon isAlign="right" isSize="large" className={`fa fa-${loading ? 'spinner fa-pulse' : 'barcode'} fa-3x`} />
                </Control>

                <Button isPulled={'right'} className="is-text" render={(props) => <Link {...props} to="/login"/>}>Cancelar</Button>
                <div style={{clear: 'both'}}></div>
              </Box>
            </ModalContent>
          </Modal>
        )
      }}
      </Mutation>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/IdentificationPage/ValidadeModule.js